import { createHttpClient } from '@thehotelsnetwork/http-client';

import { apiURL } from '@/config';

export default createHttpClient({
  baseURL: apiURL.base,
});
